import { initializeApp } from 'firebase/app';
import {
  getFirestore, collection, addDoc, getDocs, doc,
  updateDoc, onSnapshot, query, orderBy, setDoc,
  getDoc, deleteDoc, serverTimestamp, where
} from 'firebase/firestore';
import {
  getAuth, createUserWithEmailAndPassword,
  signInWithEmailAndPassword, signOut,
  onAuthStateChanged, updateProfile
} from 'firebase/auth';

// ─────────────────────────────────────────────────────────────
//  🔥 PASTE YOUR FIREBASE CONFIG HERE
//  Go to: Firebase Console → Project Settings → Your Apps → Web
// ─────────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyDtR6e13N__wmFLeWC9AK7nxnGt9T2ORyc",
  authDomain: "smartshop-581cf.firebaseapp.com",
  databaseURL: "https://smartshop-581cf-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "smartshop-581cf",
  storageBucket: "smartshop-581cf.firebasestorage.app",
  messagingSenderId: "126276430793",
  appId: "1:126276430793:web:00a2a50d7a74d2f28dd618",
  measurementId: "G-N79127S1JT"
};
// ─────────────────────────────────────────────────────────────

const app  = initializeApp(firebaseConfig);
const db   = getFirestore(app);
const auth = getAuth(app);

export {
  db, auth,
  // Firestore helpers
  collection, addDoc, getDocs, doc, updateDoc, onSnapshot,
  query, orderBy, setDoc, getDoc, deleteDoc, serverTimestamp, where,
  // Auth helpers
  createUserWithEmailAndPassword, signInWithEmailAndPassword,
  signOut, onAuthStateChanged, updateProfile
};
